<template>
    <div class="my-24">
        <div class="flex justify-between align-center">
            <h2 class="first-letter:uppercase font-semibold text-heading-2">{{ $t('interview.configure_time_slots') }}</h2>
            <div v-if="!form.instant && form.mode">
                <simple-button
                    :disabled="form.calendar_open"
                    icon="keyboard-arrow-left"
                    icon-position="left"
                    size="small"
                    @click="changeMode"
                >
                    {{ form.mode === 'calendar' ? $t('interview.select_mode.timeslots') : $t('interview.select_mode.calendar') }}
                </simple-button>
            </div>
        </div>
        <banner
            v-if="message && (form.slot_confirmed && !form.time_slots.length || form.calendar_open)"
            :description="message.content"
            :display="message.type"
            inline
            class="mt-20"
        />
        <div class="flex justify-center">
            <div class="w-full">
                <availability-scheduler
                    v-if="form.mode === 'calendar'"
                    :form="form"
                    :subs="subs"
                    :disabled="disabled"
                    :can-manage="canManage"
                    :has-bulk-timeslots="hasBulkTimeslots"
                    :creating="creating"
                    @saved="$emit('saved')"
                    :class="!message ? 'mt-20' : ''"
                ></availability-scheduler>

                <interview-timeslots
                    v-if="form.mode === 'manually'"
                    :value="form"
                    :subs="subs"
                    :alerts="alerts"
                    :has-bulk-timeslots="hasBulkTimeslots"
                    :disabled="disabled"
                    :can-manage="canManage"
                    :bulk-applications="bulkApplications"
                    :creating="creating"
                    @saved="$emit('saved')"
                />
            </div>
        </div>
    </div>
</template>
<script>
import SvgIcon from "../ui/SvgIcon.vue";
import {toUpperCase} from "uri-js/dist/esnext/util";
import NoCalendarIntegration from "../calendar/NoCalendarIntegration.vue";
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useAuthenticationStore} from '../../state/modules/authentication';
import User from "../../models/User";
import AvailabilityScheduler from "../calendar/AvailabilityScheduler.vue";
import InterviewTimeslots from "../InterviewTimeslots.vue";
import Form from "../../etc/forms/Form";
import Calendar from "../Calendar.vue";
import Banner from "../ui/Banner.vue";
import SimpleButton from "../ui/SimpleButton.vue";

export default {
    name: 'InterviewModeManager',
    components: {
        SimpleButton,
        Banner, Calendar, InterviewTimeslots, AvailabilityScheduler, NoCalendarIntegration, SvgIcon},
    props: {
        form: Form,
        subs: Array,
        alerts: Object,
        hasBulkTimeslots: Boolean,
        bulkApplications: Array,
        disabled: Boolean,
        canManage: Boolean,
        creating: {type: Boolean, default: false}
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentUserId']),
        user() {
            return useRepo(User)
                .with('calendars')
                .with('calendar_profiles', (q) => {
                    q.with('calendars');
                })
                .find(this.currentUserId);
        },
        primaryCalendar() {
            return this.user?.primary_calendar_id;
        },
        availabilities() {
            return this.user?.availability_rules;
        },
        message() {
            if (this.form.calendar_open) {
                return {
                    type: 'info',
                    content: this.$t('interview.calendar.open.message'),
                };
            }
            if (this.form.slot_confirmed) {
                return {
                    type: 'warning',
                    content: this.$t('interview.application_confirmed_slot.message'),
                }
            }
            return null;
        }
    },
    methods: {
        toUpperCase,
        changeMode() {
            if (this.form.calendar_open) {
                return;
            }

            // toggle between modes
            if (this.form.mode === 'calendar') {
                return this.form.mode = 'manually';
            }

            if (this.form.mode === 'manually') {
                return this.form.mode = 'calendar';
            }

            return this.form.mode = 'manually';
        }
    },
    beforeMount() {
        if (!this.form.time_slots.length) {
            this.form.mode = 'calendar';
        }
    },
    mounted() {
        if (this.form.calendar_open) {
            this.form.mode = 'calendar';
        }
    }
}
</script>
